export const CONFIG = {
    brandName: "Daily Gospel Network",
    tab1: "Create New Schedule",
    tab2: "View Schedules",
    BASE_URL: "https://snieswoep2.execute-api.ap-south-1.amazonaws.com/dev",
    overlapError: "Schedule Overlapping",
    BASE_URL_TEMP: "https://yumm77c5s0.execute-api.ap-south-1.amazonaws.com/dev",
    CATEGORY: "https://daily-gospel-content.s3.amazonaws.com/DGNShowCases.json",
    ALBUM:"https://api.vimeo.com/users/115195735/albums?direction=asc&page="
};